// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-content-enter-active[data-v-37d27d39],\n.dropdown-content-leave-active[data-v-37d27d39] {\n  transition: all 0.2s;\n}\n.dropdown-content-enter[data-v-37d27d39],\n.dropdown-content-leave-to[data-v-37d27d39] {\n  opacity: 0;\n  transform: translateY(-5px);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
